import * as Yup from 'yup'
const MAX_CHARACTERS = 100
const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB
const SUPPORTED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf']

export const communityPostSchema = Yup.object().shape({
  title: Yup.string()
    .required('Title is required')
    .max(MAX_CHARACTERS, `Title must be at most ${MAX_CHARACTERS} characters`),
  content: Yup.string().required('Content is required'),
  topics: Yup.array().of(Yup.string()),
  attachment: Yup.mixed()
    .nullable()
    .test('fileSize', 'File size must be less than 10MB', (value) => {
      if (!value) return true
      return value.size <= MAX_FILE_SIZE
    })
    .test('fileType', 'Only images (JPEG, PNG, GIF, WebP) and PDF files are supported', (value) => {
      if (!value) return true
      return SUPPORTED_TYPES.includes(value.type)
    })
})
